import type { ClubhouseUpdateMessage } from "Messages";
import { ClubhouseUpdateType } from "types/enums";

/**
 * Convenience function to check if a ClubhouseUpdateMessage contains a simulator
 * @param update - The ClubhouseUpdateMessage to check
 * @returns The simulator if present, undefined otherwise
 */
export function getSimulator(update: ClubhouseUpdateMessage) {
  // Try direct key access first
  if (ClubhouseUpdateType.SIMULATOR in update) {
    return update[ClubhouseUpdateType.SIMULATOR];
  }

  // Try string key
  if ("simulator" in update) {
    return update["simulator"];
  }

  return undefined;
}

/**
 * Convenience function to check if a ClubhouseUpdateMessage contains simulators
 * @param update - The ClubhouseUpdateMessage to check
 * @returns The simulators array if present, undefined otherwise
 */
export function getSimulators(update: ClubhouseUpdateMessage) {
  // Try direct key access first
  if (ClubhouseUpdateType.SIMULATORS in update) {
    return update[ClubhouseUpdateType.SIMULATORS];
  }

  // Try string key
  if ("simulators" in update) {
    return update["simulators"];
  }

  return undefined;
}
